
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-pop-parts.html
riot.tag2('menu-button-pop-parts',
  '<div if="{showPopOut}" class="bulk-actions-menu-item pop-out-action" data-tip="Pop out parts" data-track="Toolbar" data-track-action="Pop-out-Selection" data-track-label="Selection" onclick="{toggleChildrenAttachment}"> <svg class="bulk-actions-menu-item_icon"> <use xlink:href="#pop-out-icon"></use> </svg> </div> <div if="{showPopIn}" class="bulk-actions-menu-item pop-in-action" data-tip="Pop in parts" data-track="Toolbar" data-track-action="Pop-in-Selection" data-track-label="Selection" onclick="{toggleChildrenAttachment}"> <svg class="bulk-actions-menu-item_icon"> <use xlink:href="#pop-in-icon"></use> </svg> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _opts = opts,
    canvas = _opts.canvas;

this.showPopIn = opts.inorout === 'in';
this.showPopOut = opts.inorout === 'out';

this.on('update', function () {
  _this.showPopIn = opts.inorout === 'in';
  _this.showPopOut = opts.inorout === 'out';
});

this.toggleChildrenAttachment = _menuUi.mui.toggleChildrenAttachment.bind(this);
this.popInChildren = _menuUi.mui.popInChildren.bind(this);
this.popOutChildren = _menuUi.mui.popOutChildren.bind(this);
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-pop-parts')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-pop-parts.html
// module id = 737
// module chunks = 0